import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { ConfigElement } from "types/generated";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const IntentProjectEnvironmentVariablesTableDescriptionCell = ({
  item: variable,
  ...cellProps
}: TableSimpleCellProps<ConfigElement>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={variable.description} />
    </TableSimpleCell>
  );
};

export default IntentProjectEnvironmentVariablesTableDescriptionCell;
